module.exports = __webpack_public_path__ + "static/media/editsquare.2b784173.svg";